import { Skeleton } from '@/common/ui/skeleton'
import { MessageSkeleton } from './MessageSkeleton'

export function ChatRoomSkeleton() {
	return (
		<div className="flex h-full flex-col">
			<div className="flex items-center gap-3 border-b px-4 py-3">
				<Skeleton className="h-10 w-10 rounded-full" />
				<div className="space-y-2">
					<Skeleton className="h-4 w-32" />
					<Skeleton className="h-3 w-24" />
				</div>
			</div>

			<div className="flex-1 space-y-4 p-4">
				{Array.from({ length: 5 }).map((_, i) => (
					<MessageSkeleton key={i} isOutgoing={i % 2 === 0} />
				))}
			</div>

			<div className="border-t p-4">
				<Skeleton className="h-11 w-full" />
			</div>
		</div>
	)
}
